import { render, staticRenderFns } from "./CedexDependencies.vue?vue&type=template&id=27c65a0e&scoped=true&"
import script from "./CedexDependencies.vue?vue&type=script&lang=js&"
export * from "./CedexDependencies.vue?vue&type=script&lang=js&"
import style0 from "./CedexDependencies.vue?vue&type=style&index=0&id=27c65a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c65a0e",
  null
  
)

export default component.exports